export default [{
  path: '/alvaras',
  component: {
    name: 'alvarás',
    template: '<router-view />',
    meta: {
      resource: 'alvara',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'alvarás',
    component: () => import('@/app-modulo/comuns/alvara/AlvarasView.vue'),
    meta: {
      resource: 'alvara',
      action: 'read',
      navActiveLink: 'alvarás',
      pageTitle: 'Cadastro de alvarás',
      breadcrumb: [
        {
          text: 'Alvarás',
          to: { name: 'alvarás' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-alvara',
    component: () => import('@/app-modulo/comuns/alvara/shared/components/cadastro/Alvara.vue'),
    meta: {
      resource: 'alvara',
      action: 'create',
      navActiveLink: 'alvarás',
      pageTitle: 'Cadastro de alvarás',
      breadcrumb: [
        {
          text: 'Alvarás',
          to: { name: 'alvarás' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-alvara' },
          active: true,
        },
      ],
    },
  },
  {
    path: ':id',
    name: 'ver-alvara',
    component: () => import('@/app-modulo/comuns/alvara/shared/components/cadastro/Alvara.vue'),
    meta: {
      resource: 'alvara',
      action: 'read',
      navActiveLink: 'alvaras',
      pageTitle: 'Cadastro de alvaras',
      breadcrumb: [
        {
          text: 'Alvaras',
          to: { name: 'alvaras' },
        },
        {
          text: 'Editar',
          to: { name: 'ver-alvara' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar-observacao/:id',
    name: 'editar-observacao',
    component: () => import('@/app-modulo/comuns/alvara/shared/components/cadastro/Alvara.vue'),
    meta: {
      resource: 'alvara',
      action: 'read',
      navActiveLink: 'alvaras',
      pageTitle: 'Cadastro de alvaras',
      breadcrumb: [
        {
          text: 'Alvaras',
          to: { name: 'alvaras' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-observacao' },
          active: true,
        },
      ],
    },
  }],
}]
